// extracted by mini-css-extract-plugin
export default {"innerContainer":"profile__innerContainer___fEKB1"};